<template>
  <app-page-container title="گزارشات">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field
          outlined
          rounded
          placeholder="جستجو..."
          append-icon="mdi-magnify"
          dense
          v-model="searchTitle"
          class="mt-3"
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main mx-2">
        <v-col cols="12">
          <v-card elevation="0" class="card-width body-card">
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="3" v-for="(item, index) in filterdList" :key="index">
                      <v-card
                        elevation="0"
                        class="items-card-8"
                        :style="item.background"
                        height="20vh"
                      >
                        <v-card-text>
                          <v-card
                            elevation="0"
                            class="items-card-inside-8 mr-4 ml-n4"
                            :style="item.background2"
                            height="16vh"
                          >
                            <v-card elevation="3" class="items-card-inside-3 mr-4" height="16vh">
                              <v-card-text>
                                <v-row>
                                  <v-icon color="#E7F3FF" class="mr-2">{{ item.icon2 }}</v-icon>
                                  <v-spacer></v-spacer>
                                </v-row>
                                <v-row class="mt-2">
                                  <v-spacer></v-spacer>
                                  <span
                                    class="inside-card-title line-clamp-1"
                                    @click="goToReport(item.title)"
                                  >
                                    {{ item.title }}
                                  </span>
                                  <v-spacer></v-spacer>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-card>
                          <v-icon class="mt-n10" color="white">{{ item.icon }}</v-icon>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <alert-component
          ref="snackRef"
          :snakTimeOut="snakTimeOut"
          :snackColor="snackColor"
          :snackText="snackText"
          :snakIcon="snakIcon"
        ></alert-component>
      </section>
    </template>
  </app-page-container>
</template>
<script>
  import AlertComponent from '@/components/AlertComponent.vue';
  import AppPageContainer from '@/components/app/PageContainer.vue';
  import snackBar from '@/Mixins/snackBar.js';
  import ShearedMixin from '@/Mixins/Shared.js';
  import ShearedHelper from '@/Helpers/Shared.js';
  import QCReportsHelper from '@/Helpers/QC/QCReportsHelper.js';
  export default {
    name: 'QCReports',
    title: 'گزارشات کنترل کیفیت',
    inject: ['load', 'tableImg', 'tableTitleImage'],
    components: {
      AlertComponent,
      AppPageContainer,
    },
    mixins: [ShearedMixin, snackBar, ShearedHelper, QCReportsHelper],
    created() {
      this.$root.$refs.QCReports = this;
    },
    mounted() {
      this.mounteLoding();
    },
    data() {
      return {};
    },
    methods: {
      mounte: function () {},
    },
    computed: {
      filterdList() {
        return this.qcReports.filter((u) => {
          return u.title.toLowerCase().includes(this.searchTitle.toLowerCase());
        });
      },
    },
  };
</script>
<style scoped>
  .confirm-cancel-btn {
    border: solid 1px var(--dark-color);
    padding-top: 13px;
    padding-bottom: 15px;
    color: var(--dark-color);
  }
  .body-card {
    height: 80vh;
    overflow-y: auto !important;
  }
  @media only screen and (min-width: 1280px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1366px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 98.5% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1536px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 1vh !important;
    }
  }
  .items-card-8 {
    border-radius: 12px !important;
  }
  .items-card-inside-8 {
    border-bottom-right-radius: 250px !important;
  }
  .items-card-inside-3 {
    border-bottom-right-radius: 250px !important;
    margin-left: -16vh !important;
    border-top-left-radius: 12px !important;
    border-bottom-left-radius: 12px !important;
  }
  .inside-card-title {
    font-weight: 500;
    font-size: 18px;
    color: #212121;
    margin-top: 8px;
    letter-spacing: normal;
    cursor: pointer;
    max-width: 200px;
  }
</style>
